module.exports = __webpack_public_path__ + "img/request.e26839f8.svg";